/**
 * @module config
 * @description Service for the application configuration
 * @copyright Aura Health, Inc.
 */

// Internal dependencies
const { name, version } = require('./package.json');

// Store the configuration
const config = {
  environment: process.env.NODE_ENV,
  port: process.env.PORT,
  mode: process.env.NEXT_PUBLIC_MODE,
  appDomain: process.env.NEXT_PUBLIC_APP_DOMAIN,
  firebase: {
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  },
  mixpanel: {
    token: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,
  },
  service: {
    name,
    version,
  },
  bugsnag: {
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_KEY,
    releaseStage: process.env.NEXT_PUBLIC_MODE,
    appVersion: version,
  },
  api: {
    auraServices: process.env.NEXT_PUBLIC_AURA_SERVICES_URL,
    auraServicesToken: process.env.NEXT_PUBLIC_AURA_SERVICES_TOKEN,
    apiUrl: process.env.NEXT_PUBLIC_API_URL,
    shield: process.env.NEXT_PUBLIC_SHIELD,
    shieldFunction: process.env.NEXT_PUBLIC_SHIELD_FUNCTION,
  },
  stripe: {
    stripeKey: process.env.NEXT_PUBLIC_STRIPE_KEY,
    stripeSecretKey: process.env.NEXT_PUBLIC_STRIPE_SECRET_KEY,
  },
  branch: {
    branchKey: process.env.NEXT_PUBLIC_BRANCH_KEY,
  },
  payPalId: {
    clientId: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID,
  },
  pixel: {
    web: process.env.NEXT_PUBLIC_PIXEL_ID,
    webAndroid: process.env.NEXT_PUBLIC_PIXEL_ANDROID_ID,
    webIos: process.env.NEXT_PUBLIC_PIXEL_IOS_ID,
  },
  geolocationDbKey: process.env.NEXT_PUBLIC_GEOLOCATION_DB_KEY,
  googleTagManagerId: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
  coachWeb: process.env.NEXT_PUBLIC_COACH_WEB,
  userWeb: process.env.NEXT_PUBLIC_USER_WEB,
};

module.exports = config;
